// <editor-fold desc="Pages">
import { lazy } from 'react';

const Home = lazy(() => import('@/pagesComponents/Home'));
const TirageEnCours = lazy(() => import('@/pagesComponents/TirageEnCours'));
const HistoriqueDAchats = lazy(() => import('@/pagesComponents/HistoriqueDAchat'));
const Receipts = lazy(() => import('@/pagesComponents/Receipts'));
const Contact = lazy(() => import('@/pagesComponents/Contact'));
const RegisterConfirm = lazy(() => import('@/pagesComponents/RegisterConfirm'));
const Faq = lazy(() => import('@/pagesComponents/Faq'));
const Profile = lazy(() => import('@/pagesComponents/Profile'));
const ResetPassword = lazy(() => import('@/pagesComponents/ResetPassword'));

const Achats = lazy(() => import('@/pagesComponents/Achats'));
const LegalDoc = lazy(() => import('@/pagesComponents/legals/LegalDoc'));
const ConfirmEmail = lazy(() => import('@/pagesComponents/ConfirmEmail'));
// const NoPage = lazy(() => import("@/pagesComponents/NoPage"));
//</editor-fold>

export const documentIds = {
  GeneralConditions: 7,
  OnlineGameConditions: 2,
  GameRegulations: 8,
  Contacts: 9,
  FAQ: 14,
};

/**
 *
 * @typedef {Object} Route
 * @property {string} name - The name of the route.
 * @property {string} path - The path of the route.only use single level paths this won`t work : path: "/achats/:tirageId" and should use searchparams insead
 * @property {JSX.Element} element - The React element to render for the route.
 * @property {boolean} [navBar] - Indicates if the route should be included in the navigation bar. Defaults to false.
 * @property {boolean} [active] - Indicates if the route is active. Defaults to false.
 * @property {boolean} [footerLegals] - Indicates if the route should be included in the footer legal documents. Defaults to false.
 */
export const routes = [
  {
    name: 'Accueil',
    path: '/',
    element: <Home/>,
    navBar: true,
    active: false,
    public: true,
  },
  {
    name: 'Tirage en cours',
    path: '/tirage-en-cours',
    element: <TirageEnCours/>,
    navBar: true,
    active: false,
    public: true,
  },
  {
    name: 'Historique d\'achats',
    path: '/historique-dachats',
    element: <HistoriqueDAchats/>,
    navBar: true,
    active: false,
    public: false,
  },

  {
    name: 'Contact',
    path: '/contact-us',
    element: <Contact/>,
    active: false,
    public: true,
  },
  { name: 'Faq', path: '/faq', element: <Faq/>, active: false, public: true },
  {
    name: 'Profile',
    path: '/profile',
    element: <Profile/>,
    active: false,
    public: false,
  },

  {
    name: 'Achats',
    path: '/achats',
    element: <Achats/>,
    active: false,
    public: false,
  },
  {
    name: 'Confirmation d\'enregistrement',
    path: '/confirmation-enregistrement',
    element: <RegisterConfirm/>,
    active: false,
    public: true,
  },
  {
    name: 'Confirmation d\'email',
    path: '/confirm-email',
    element: <ConfirmEmail/>,
    active: false,
    public: true,
  },
  {
    name: 'Réinitialisation du mot de passe',
    path: '/reset-password',
    element: <ResetPassword/>,
    active: false,
    public: true,
  },
  {
    name: 'Reçus',
    path: '/receipts',
    element: <Receipts/>,
    active: false,
    public: false,
  },

  //footer
  {
    name: 'Conditions générales d\'utilisation',
    path: '/conditions-generales-utilisation',
    element: <LegalDoc id={documentIds.GeneralConditions}/>,
    active: false,
    footerLegals: true,
    public: true,
  },
  {
    name: 'Conditions d\'utilisation - jeu en ligne',
    path: '/conditions-utilisation-jeu-en-ligne',
    element: <LegalDoc id={documentIds.OnlineGameConditions}/>,
    active: false,
    footerLegals: true,
    public: true,
  },
  {
    name: 'Règlements du jeu',
    path: '/reglements-du-jeu',
    element: <LegalDoc id={documentIds.GameRegulations}/>,
    active: false,
    footerLegals: true,
    public: true,
  },

  // goggle referenced routes
  {
    name: 'Old Rules',
    path: 'Home/MessageInfo/8',
    element: <LegalDoc id={documentIds.GameRegulations}/>,
    active: false,
    public: true,
  },
  {
    name: 'Old Faq',
    path: 'Home/MessageInfo/14',
    element: <Faq/>,
    active: false,
    public: true,
  },
  {
    name: 'Old Achat',
    path: 'Home/SubscribeForPurchase',
    element: <Achats/>,
    active: false,
    public: false,
  },
  {
    name: 'Old Login',
    path: 'Account/Login',
    element: <Home/>,
    active: false,
    public: true,
  },
  {
    name: 'Old Register',
    path: 'Account/Register',
    element: <Home/>,
    active: false,
    public: true,
  },
];

export default routes;
